// extracted by mini-css-extract-plugin
export default {"container":"Preloader_container__F6bst","preloader":"Preloader_preloader__dBEKc"};